module.exports = __webpack_public_path__ + "static/img/shrunk_bear@2x.5836e1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/downgrade-animation/images/shrunk_bear@2x.png
// module id = /4Gg
// module chunks = 12